// decrypt.js
import CryptoJS from 'crypto-js';
let secretKey = process.env.REACT_APP_SECRET_KEY_ENCRYPTION

export const decryptData = (encryptedData) => {
  // Handle undefined, null, or non-string data
  if (!encryptedData || typeof encryptedData !== 'string') {
    return encryptedData || [];
  }
  
  try {
  const bytes = CryptoJS.AES.decrypt(encryptedData, secretKey);
  const originalText = bytes.toString(CryptoJS.enc.Utf8);
  if(originalText){
    return JSON.parse(originalText);
  }else{
      return encryptedData || [];
    }
  } catch (error) {
    console.error("Decryption error:", error);
    // If decryption fails, return the original data (might not be encrypted)
    return encryptedData || [];
  }
};
